var deleteUrl = '';

$(document).ready(function () {


    /**
     *
     */

    /**
     * function for hamburger menu
     * @type {{init}}
     */
    var DocumentationLayout = function () {

        var toggleSideBar = function (){
            var icon = $('.hamburger').first();
            $('body').toggleClass('sidebar-open');
            icon.toggleClass('is-active');
        };

        var handleSideBar = function () {
            // Sidebar menu slide
            $('.side-nav .has-child a').on('click',function(e){
                var menu = $(this).next('.sub-menu'),listItem = $(this).parent('li');

                menu.collapse('toggle');
                listItem.toggleClass('open');
            });

            // Open the menu if Active
            var openMenus = $('.side-nav .has-child.open').find('.sub-menu');
            openMenus.collapse('show');

            $('.nav-toggle').on('click',function(e){
                e.preventDefault();
                toggleSideBar();
            });

        };

        var handleMobileOverlay = function () {
            $('.mobile-menu-overlay').on('click',function(e){
                e.preventDefault();

                toggleSideBar();
            });
        };

        var handleClipBoard = function(){
            /* Prism copy to clipbaord for all pre with copytoclipboard class */
            $('pre.copytoclipboard').each(function () {
                $this = $(this);
                $button = $('<button>Copy to Clipboard</button>');
                $this.wrap('<div/>').removeClass('copytoclipboard');
                $wrapper = $this.parent();
                $wrapper.addClass('copytoclipboard-wrapper').css({position: 'relative'})
                $button.css({position: 'absolute', top: 10, right: 10}).appendTo($wrapper).addClass('copytoclipboard btn btn-default btn-sm');
                /* */
                var copyCode = new Clipboard('button.copytoclipboard', {
                    target: function (trigger) {
                        return trigger.previousElementSibling;
                    }
                });
                copyCode.on('success', function (event) {
                    event.clearSelection();
                    event.trigger.textContent = 'Copied';
                    window.setTimeout(function () {
                        event.trigger.textContent = 'Copy';
                    }, 2000);
                });
                copyCode.on('error', function (event) {
                    event.trigger.textContent = 'Press "Ctrl + C" to copy';
                    window.setTimeout(function () {
                        event.trigger.textContent = 'Copy';
                    }, 2000);
                });
            });
        };



        return {
            //main function to initiate the module
            init: function () {
                handleSideBar();
                handleMobileOverlay();
                handleClipBoard();
            }
        };

    }();


    jQuery(document).ready(function() {
        DocumentationLayout.init();
    });

    $('input[name=zipcode]').change(function(){

        if ($('input[name=number]').val() !== ""){
            var zipcode = $(this).val().replace(/\s/g,'');
            var number = $('input[name=number]').val().replace(/\s/g,'');
            $.getJSON("/api/v1/internal/postcode?zipcode="+zipcode+"&number="+number, function(data, status){

                if(status == "success"){
                    data = data._embedded.addresses;
                    $('input[name=street]').val(data[0].street);
                    $('input[name=city]').val(data[0].city.label);
                    $('input[name=zipcode]').val(data[0].postcode);
                    $('.select').val('150').trigger('change');
                }
            });
        }

    });

    $('input[name=number]').change(function(){
        if ($('input[name=zipcode]').val() !== ""){
            var zipcode =$('input[name=zipcode]').val().replace(/\s/g,'');
            var number = $(this).val().replace(/\s/g,'');
            $.getJSON("/api/v1/internal/postcode?zipcode="+zipcode+"&number="+number, function(data, status){

                if(status == "success"){
                    data = data._embedded.addresses;
                    $('input[name=street]').val(data[0].street);
                    $('input[name=city]').val(data[0].city.label);
                    $('input[name=zipcode]').val(data[0].postcode);
                    $('.select').val('150').trigger('change');
                }
            });
        }

    });


    // Menu
    $("#menu").metisMenu();

    // Generic alert on body
    if ($("body").hasClass('show-alert')) {
        notie.alert($('body').data('message-type'), $('body').data('message'), 2);
    }

    // Generic delete function
    $('body').on('click','.confirm-dialog',function (e) {
        e.preventDefault();
        deleteUrl = $(this).attr('href');
        notie.confirm($(this).data('message'), 'Yes', 'No', function () {
            window.location.href = deleteUrl;
        });
    });

    // Selectbox nice
    $('.select').select2();


    if ($('.venue').length>0) {
        updateSelectBox($('.venue').val());
    }


    $('.venue').on('select2:select', function (e) {
        updateSelectBox($(this).val());
    });

    function updateSelectBox(id){
        var currentId = $('#seatplan').data('current');
        $.getJSON("/api/v1/internal/venues/"+ id +"/seatplans", function(result) {
            var data = [];
            var seatplans = result.data;
            if(result.recordsFiltered > 0){
                for (var i = 0; i < seatplans.length; i++){
                    var seatplan = seatplans[i];
                    data.push({id:seatplan.id,
                        text:seatplan.name});
                }
                $('#seatplan').select2('destroy').empty().select2({data:data}).prop( "disabled", false ).val(currentId).trigger('change');
            }
            else{
                $('#seatplan').select2('destroy').empty().select2({data:[{id:0,text:"Select venue first"}]}).prop( "disabled", true);
            }
        });
    }
    // Validate all forms having parsley-validate as a class
    $('form.parsley-validate').parsley();

    // Select user rights
    $("input.rights_click").click(function () {
        if ($(this).is(":checked")) {
            $.each($("input." + $(this).data('key')), function (index, item) {
                $(item).prop('checked', true);
            });
        } else {
            $.each($("input." + $(this).data('key')), function (index, item) {
                $(item).prop('checked', false);
            });
        }
    });

    $('.date-field').datepicker({
        format: 'dd-mm-yyyy',
        autoclose: true,
    });

    $('.time-field').clockpicker({
        autoclose: true,
        placement: 'top'

    });

});
